/**
 * Product New JS - JavaScript for product.new.json
 * v5.3 - CRITICAL FIX: Removed applyStyles() and delays. JS now focuses ONLY on utility/locales, eliminating conflict with video-core.js.
 */

(function() {
  'use strict';
  
  if (window.productNewJsInitialized) {
    return;
  }
  window.productNewJsInitialized = true;

  // ------------------------------------------------------------
  // Localization System 
  // ------------------------------------------------------------
  const i18n = {
    translations: {
      'Almost sold out': 'Casi agotado',
      'left': 'restantes',
      'SAVE BIG WITH OUR PACKS': 'AHORRA EN GRANDE CON NUESTROS PAQUETES',
      'EXCLUSIVE OFFER': 'OFERTA EXCLUSIVA',
      'Save 10%': 'Ahorra 10%',
      'Code copied!': '¡Código copiado!',
      'Apply at checkout': 'Aplicar al finalizar la compra',
      'Free shipping': 'Envío gratuito',
      'Secure payment': 'Pago seguro',
      '30-day returns': 'Devoluciones 30 días',
      'Description': 'Descripción',
      'Perfect Fit Details': 'Detalles del Ajuste Perfecto',
      'Fabric & Care Tips': 'Tela y Consejos de Cuidado',
      'Shipping Information': 'Información de Envío'
    },
    
    currentLocale: 'en',
    
    init: function() {
      const htmlLang = document.documentElement.getAttribute('lang') || '';
      const isSpanish = htmlLang.toLowerCase().includes('es');
      const shopifyLocale = window.Shopify?.locale;
      const isSpanishShopify = shopifyLocale && shopifyLocale.toLowerCase().includes('es');
      
      if (isSpanish || isSpanishShopify) {
        this.currentLocale = 'es';
        this.applyTranslations();
      }
    },
    
    translate: function(text) {
      if (this.currentLocale !== 'es') return text;
      return this.translations[text] || text;
    },
    
    applyTranslations: function() {
      if (this.currentLocale !== 'es') return;
      
      const elementsToTranslate = [
        { selector: '.pack-section-title', text: 'SAVE BIG WITH OUR PACKS' },
        { selector: '.promo-title', text: 'EXCLUSIVE OFFER' },
        { selector: '.promo-subtitle', text: 'Save 10%' },
        { selector: '.success-title', text: 'Code copied!' },
        { selector: '.success-subtitle', text: 'Apply at checkout' },
        { selector: '.description-title', text: 'Description' }
      ];
      
      elementsToTranslate.forEach(item => {
        document.querySelectorAll(item.selector).forEach(el => {
          if (el.textContent.trim() === item.text) {
            el.textContent = this.translate(item.text);
          }
        });
      });
      
      document.querySelectorAll('.trust-item span, .tab-title').forEach(el => {
        const originalText = el.textContent.trim();
        const translated = this.translate(originalText);
        if (translated !== originalText) {
          el.textContent = translated;
        }
      });
    }
  };
  
  i18n.init();
  window.i18n = i18n;

  // ------------------------------------------------------------
  // Safe DOM Execution
  // ------------------------------------------------------------
  function safeExecute(fn, context = 'Unknown') {
    try {
      return fn();
    } catch (error) {
      console.error(`[ProductNew] Error in ${context}:`, error);
      return null;
    }
  }

  // ------------------------------------------------------------
  // Almost Sold Out function
  // ------------------------------------------------------------
  function setupImprovedAlmostSoldOut() {
    const container = document.getElementById('almostSoldOut');
    if (!container) return;
    
    safeExecute(() => {
      const now = new Date();
      let dayOfWeek = now.getDay(); 
      const dayIndex = (dayOfWeek === 0) ? 6 : dayOfWeek - 1;
      
      const seed = dayIndex + now.getDate();
      const random = ((seed * 9301 + 49297) % 233280) / 233280;
      const currentCount = Math.floor(random * 8) + 3; 
      
      const almostSoldOutText = i18n.translate('Almost sold out');
      const leftText = i18n.translate('left');
      
      container.innerHTML = `
        <div class="indicator-wrapper">
          <div class="indicator-dot"></div>
          <div class="pulse-ring"></div>
        </div>
        <div class="almost-sold-out-text">
          ${almostSoldOutText} - <span class="count-text">${currentCount}</span> ${leftText}
        </div>
      `;
      
      // Убеждаемся, что контейнер отображается, если он не пуст
      container.style.display = 'flex'; 

    }, 'setupImprovedAlmostSoldOut');
  }

  // ------------------------------------------------------------
  // Promo Copy
  // ------------------------------------------------------------
  function setupPromoCopy() {
    safeExecute(() => {
      const promoCard = document.querySelector('[data-copy-promo]');
      if (!promoCard || promoCard.hasAttribute('data-initialized')) return;
      
      promoCard.setAttribute('data-initialized', 'true');
      
      promoCard.addEventListener('click', function(e) {
        e.preventDefault();
        const codeText = this.querySelector('.code-text');
        if (!codeText) return;
        
        navigator.clipboard.writeText(codeText.textContent.trim())
          .then(() => {
            const msg = document.getElementById('copyMessage');
            if (msg) {
              msg.classList.add('show');
              setTimeout(() => msg.classList.remove('show'), 3000);
            }
          })
          .catch(err => {
            // Fallback (Убран лишний console.error, чтобы избежать спама)
            const textArea = document.createElement("textarea");
            textArea.value = codeText.textContent.trim();
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            
            const msg = document.getElementById('copyMessage');
            if (msg) {
              msg.classList.add('show');
              setTimeout(() => msg.classList.remove('show'), 3000);
            }
          });
      });
    }, 'setupPromoCopy');
  }

  // ------------------------------------------------------------
  // Collapsibles (Description and Tabs)
  // ------------------------------------------------------------
  function setupCollapsibles() {
    safeExecute(() => {
      // 1. Description Collapsible
      const descriptionHeader = document.querySelector('.description-header[data-toggle-description]');
      if (descriptionHeader && !descriptionHeader.hasAttribute('data-initialized')) {
        descriptionHeader.setAttribute('data-initialized', 'true');
        descriptionHeader.addEventListener('click', function(e) {
          e.preventDefault();
          const parent = this.closest('.expandable-description');
          if (parent) {
            parent.classList.toggle('active');
          }
        });
      }
      
      // 2. Aligned Tabs Collapsible
      document.querySelectorAll('.tab-header[data-toggle-tab]').forEach(header => {
        if (header.hasAttribute('data-initialized')) return;
        header.setAttribute('data-initialized', 'true');
        
        header.addEventListener('click', function(e) {
          e.preventDefault();
          const item = this.closest('.tab-item');
          if (!item) return;
          
          const isActive = item.classList.contains('active');
          
          document.querySelectorAll('.aligned-tabs .tab-item').forEach(tab => {
            tab.classList.remove('active');
          });
          
          if (!isActive) {
            item.classList.add('active');
          }
        });
      });
    }, 'setupCollapsibles');
  }
  
  // ------------------------------------------------------------
  // Main Initialization
  // ------------------------------------------------------------
  function initialize() {
    setupImprovedAlmostSoldOut();
    setupPromoCopy();
    setupCollapsibles();
    // i18n.applyTranslations() уже вызывается в i18n.init()
  }

  // ------------------------------------------------------------
  // Startup & Event Listeners
  // ------------------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    // Небольшая задержка 100 мс, чтобы дать возможность загрузиться Minimog/Vimotia
    setTimeout(initialize, 100); 
  }
  
  // Re-initialize after theme editor changes or section loads
  document.addEventListener('shopify:section:load', () => {
    // Даём сторонним приложениям (Vimotia) время на перехват медиа
    setTimeout(initialize, 300); 
  });
  
  document.addEventListener('variant:changed', () => {
    // Обновление 'Almost Sold Out' при смене варианта
    setTimeout(setupImprovedAlmostSoldOut, 300); 
  });
})();